/**
 * Checks if `value` is empty.
 * @example
 *
 * isEmpty(null)
 * // => true
 *
 * isEmpty(true)
 * // => true
 *
 * isEmpty(1)
 * // => true
 *
 * isEmpty('abc')
 * // => false
 *
 * isEmpty({ a: 1 })
 * // => false
 *
 * isEmpty([1, 2, 3])
 * // => false
 *
 * isEmpty({})
 * // => true
 *
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isEmpty(value: any): boolean {
  if (value === null) return true;

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key in value) {
    if (Object.hasOwnProperty.call(value, key)) {
      return false;
    }
  }

  return true;
}
